import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-segments',
  templateUrl: './customer-segments.component.html',
  styleUrls: ['./customer-segments.component.scss']
})
export class CustomerSegmentsComponent {}



// WEBPACK FOOTER //
// ./src/app/modules/customer-segments/customer-segments.component.ts